import React from 'react';
import { ListRenderItem } from 'react-native';

import Container from '@src/components/Container';
import RefreshControl from '@src/components/RefreshControl';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import useViewableItems from '@src/hooks/useViewableItems';
import { Business } from '@src/types';

import BusinessItem from './BusinessItem';
import Heading from './Heading';
import { List } from './styled';
import { Props } from './types';
import useLocations from './useLocations';

const Screen: React.FC<Props> = () => {
  const locations = useLocations();
  const { handleViewableItemsChanged, viewabilityConfig } = useViewableItems();
  const handleScroll = useAnimatedHeader();

  const renderItem: ListRenderItem<Business> = ({ item }) => (
    <BusinessItem item={item} />
  );

  const keyExtractor = (item: Business): string => {
    const randomId = Math.floor(Math.random() * 100000000);
    return `${item.id}-${item.name}-${randomId}`;
  };

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          ListHeaderComponent={
            <Heading
              search={locations.search}
              onChangeSearch={locations.setSearch}
            />
          }
          onScroll={handleScroll}
          refreshControl={
            <RefreshControl
              refreshing={locations.refreshing}
              onRefresh={locations.handleRefresh}
            />
          }
          onViewableItemsChanged={handleViewableItemsChanged}
          viewabilityConfig={viewabilityConfig}
          onEndReached={locations.handleEndReached}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          data={locations.data}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'Location';

export default Screen;
